//* Local or Custom Libraries
import {
  USER_COUNTRY,
  noNearbyStoresAvailableMessage,
  noResultsFoundMessage,
  notAvailableMessage
} from "../utilities/constants";

//* Importing Styles
import styles from "../bopis-modal.module.scss";

/**
 * @param {object} searchQueryError - an error set from the geocodeAddress function if no address could be found
 * @param {function|undefined} setDeliveryToShip - a function that changes delivery type to SHP
 * @param {string} userCountry - The country code of the user (e.g., "US" or "CA").
 * @param {string} userSearchedQuery - The search query entered by the user.
 */

const BopisSearchQueryMessage = ({
  searchQueryError,
  setDeliveryToShip,
  userCountry,
  userSearchedQuery
}) => {
  const displayMessage = () => {
    if (searchQueryError) {
      return notAvailableMessage;
    } else if (userSearchedQuery) {
      return noNearbyStoresAvailableMessage + " " + userSearchedQuery;
    } else {
      return noResultsFoundMessage;
    }
  };

  return (
    <div className={styles.notAvailableMessage}>
      <div className={styles.message}>
        <p className={styles.notAvailableTextStyle}>{displayMessage()}</p>
        <p className={styles.searchForStoreText}>Try searching for store by:</p>
        <ul>
          {userCountry === USER_COUNTRY.US ? (
            <>
              <li>Zip Code</li>
              <li>City, State</li>
              <li>or Increase Search Distance</li>
            </>
          ) : (
            <>
              <li>Postal Code</li>
              <li>City, Province</li>
            </>
          )}
        </ul>
      </div>
      <div className={styles.changeToShippingTextAndButton}>
        <p className={styles.cannotFindItem}>
          Can’t find what you are looking for? We can
        </p>
        <button onClick={setDeliveryToShip} className="lll-link-primary">
          Ship it to you
        </button>
      </div>
    </div>
  );
};

export default BopisSearchQueryMessage;
